import { alpha, type Theme } from "@mui/material/styles";
import { getBrandedPrimaryButtonStyles } from "./buttonThemeOverrides";

/** Icons inside dialog buttons inherit the button label color. */
const dialogButtonIconInherit = {
  "& .MuiButton-root .MuiButton-startIcon, & .MuiButton-root .MuiButton-endIcon": {
    color: "inherit",
  },
  "& .MuiButton-root .MuiButton-startIcon .MuiSvgIcon-root, & .MuiButton-root .MuiButton-endIcon .MuiSvgIcon-root":
    {
      color: "inherit",
    },
};

/** Dialog-scoped branding: buttons in DialogActions + form controls in DialogContent. */
export function getDialogThemeOverrides(theme: Theme) {
  const { primary, containedPrimary, outlinedPrimary } =
    getBrandedPrimaryButtonStyles(theme);

  const dialogActionsContained = {
    "& .MuiDialogActions-root .MuiButton-contained:not(.MuiButton-containedError)":
      containedPrimary,
    "& .MuiDialogActions-root .MuiButton-outlined:not(.MuiButton-outlinedError)":
      outlinedPrimary,
    "& .MuiDialogActions-root .MuiButton-text:not(.MuiButton-textError)": {
      color: primary,
      "&:hover": {
        backgroundColor: alpha(primary, 0.04),
      },
    },
  };

  const dialogContentControls = {
    "& .MuiDialogContent-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
      {
        borderColor: primary,
      },
    "& .MuiDialogContent-root .MuiCheckbox-root.Mui-checked, & .MuiDialogContent-root .MuiCheckbox-root.MuiCheckbox-indeterminate":
      {
        color: primary,
      },
    "& .MuiDialogContent-root .MuiRadio-root.Mui-checked": {
      color: primary,
    },
    "& .MuiDialogContent-root .MuiSwitch-root .Mui-checked": {
      color: primary,
      "& + .MuiSwitch-track": {
        backgroundColor: primary,
        opacity: 0.5,
      },
    },
    "& .MuiDialogContent-root .MuiSwitch-root .Mui-checked.Mui-disabled": {
      color: theme.palette.action.disabled,
    },
    "& .MuiDialogContent-root .MuiFormLabel-root.Mui-focused": {
      color: primary,
    },
    "& .MuiDialogContent-root .MuiInputLabel-root.Mui-focused": {
      color: primary,
    },
    // Buttons placed inside DialogContent (not DialogActions)
    "& .MuiDialogContent-root .MuiButton-contained:not(.MuiButton-containedError)":
      containedPrimary,
    "& .MuiDialogContent-root .MuiButton-outlined:not(.MuiButton-outlinedError)":
      outlinedPrimary,
    "& .MuiDialogContent-root .MuiButton-text:not(.MuiButton-textError):not(.concepts-category-nav-btn)": {
      color: primary,
    },
  };

  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          ...dialogActionsContained,
          ...dialogContentControls,
          ...dialogButtonIconInherit,
        },
      },
    },
  };
}
